module.exports = __webpack_public_path__ + "static/img/goods-list-img02.26767bb0.svg";